import { useGtm } from '@gtm-support/vue-gtm'

export type EventName =
  | 'add_payment_info'
  | 'add_personal_info'
  | 'add_shipping_info'
  | 'add_to_cart'
  | 'remove_from_cart'
  | 'begin_checkout'
  | 'generate_lead'
  | 'purchase'
  | 'search'
  | 'select_item'
  | 'share'
  | 'view_cart'
  | 'view_item'
  | 'product_catalog_deactivated_button_click'
  | 'product_catalog_freebanner'
  | 'view_promotion'
  | 'working_lead'
  | 'product_suggested_item_click'
  | 'product_suggested_item_add'
  | 'product_image_zoom_click'
  | 'product_catalog_home_grid_view_click'
  | 'product_catalog_home_list_view_click'
  | 'product_catalog_home_mosaic_view_click'
  | 'product_mosaic_product_click'
  | 'product_item_cell_grid_image_swipe'
  | 'product_catalog_coupon_applied'
  | 'product_catalog_coupon_removed'
  | 'product_catalog_open_coupon_modal_click'

export type MetaEventName =
  | 'AddPaymentInfo'
  | 'AddToCart'
  | 'InitiateCheckout'
  | 'Lead'
  | 'Purchase'
  | 'Search'
  | 'ViewContent'
  | 'PageView'
  | 'Contact'

export const useEvent = () => {
  const gtm = useGtm()
  const globalStore = useGlobalStore()

  const event = (name: EventName, value: object = {}, key = 'ecommerce') => {
    const enhancedPayload: Record<string, any> = { ...value }

    if (globalStore.store) {
      enhancedPayload.rr_store_id = globalStore.store.id ?? ''
      enhancedPayload.rr_store_host = window.location.host
      enhancedPayload.rr_store_handle = globalStore.store.handle ?? ''
    }

    if (globalStore.store.salesperson) {
      enhancedPayload.rr_salesperson_id = globalStore.store.salesperson.id
      enhancedPayload.rr_salesperson_handle = globalStore.store.salesperson.handle
    }

    gtm?.trackEvent({ event: name, [key]: enhancedPayload })
  }

  return {
    event,
    metaEvent: (event: MetaEventName, payload?: unknown) => {
      const fbq = window.fbq

      if (globalStore.store.storefrontPreferences?.analytics?.metaPixelId && fbq) {
        fbq('track', event, payload)
      }
    },
  }
}
